import ConfigurationService from './ConfigurationService';

export default ConfigurationService;
